import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IExpense, PaginateResponse } from '@tacliatech/types';

@Injectable({
  providedIn: 'root',
})
export class ExpenseSearchService {
  constructor(private http: HttpClient) {}

  search(query: { [key: string]: any } = {}) {
    const params = new HttpParams({
      fromObject: {
        ...query,
      },
    });

    return this.http.get<PaginateResponse<IExpense[]>>(
      `:API_URL/search/expenses`,
      {
        params,
      }
    );
  }
}
